
// Reads the beneficiary out of a "Please make a bank transfer to <name>" note.
// `\bto\s+` needs a word boundary plus trailing space, so "total" never matches.
// The capture stays permissive: a character class would drop names with brackets, slashes or
// accents to null, and null falls back to the wrong (F4B) account name — the bug this fixes.
function getBeneficiaryFromNote(note) {
  const [, captured] = String(note || '').match(/\bto\s+(.+)$/i) || [];
  let name = (captured || '').trim();
  const sentenceBreak = /[.!?]\s+/g;
  let match;

  // Cut appended instruction text, but only at a sentence break whose remainder reads like
  // prose — i.e. contains a word starting lowercase. "Ltd. Thank you." is cut, while names
  // such as "J.K. Foods" and "Kwame Ltd. Sons" survive intact.
  while ((match = sentenceBreak.exec(name))) {
    if (/\b[a-z]/.test(name.slice(match.index + match[0].length))) {
      name = name.slice(0, match.index);
      break;
    }
  }

  return name.trim().replace(/[.!?\s]+$/, '') || null;
}

export { getBeneficiaryFromNote };
